<template>
  <!--没有子项目或者只有一个子项目则显示menu-item-->

  <Submenu :name="parentItem.name">
    <template slot="title">
      <Icon type="ios-navigate" v-if="parentItem.icon"></Icon>
      <span>{{(parentItem.meta && parentItem.meta.title) || parentItem.name }}</span>
    </template>
    <template v-for="item in parentItem.children">
      <template v-if="item.children && item.children.length === 1">
        <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
        <menu-item v-else :name="getNameOrHref(item, true)" :key="`menu-${item.children[0].name}`">
          <Icon type="ios-navigate" v-if="item.icon"></Icon>
          <span>{{ getTitle(item.children[0]) }}</span>
        </menu-item>
      </template>
      <template v-else>
        <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
        <menu-item v-else :name="getNameOrHref(item)" :key="`menu-${item.name}`">
          <Icon type="ios-navigate" v-if="item.icon"></Icon>
          <span>{{ getTitle(item) }}</span>
        </menu-item>
      </template>
    </template>
  </Submenu>
</template>
<script>
  import layoutMixin from './layout-mixin'
export default {
  name: 'SideMenuItem',
  mixins:[layoutMixin],
  props:{
    parentItem:{
      type:Object,
      default: () => {}
    },
  },
}
</script>
